import axios from 'axios';
import { getAppToken, getSelfToken } from '../_helpers/auth/secureToken';
const BASE_URL = process.env.REACT_APP_BASEURL;

class APIService {
  constructor(baseURL) {
    this.baseURL = baseURL || BASE_URL;
    this.api = axios.create({
      baseURL: this.baseURL
    });

    // Define your endpoints here
    this.endpoints = {
      titleVersion: "/releases/title_version/",
      copyrightList: "/releases/copyright/",
      copyrightCreate: "/releases/copyright_add",
      copyrightUpdate: "/releases/copyright_add",
      overviewData: "/releases/overview/studio",
      trackData: "/releases/allsongs/studio",
      albumData: "/releases/allalbums/studio",
      singleDetails: "/releases/songs",
      singleMonthDetails: "/releases/month",
      storeData: "/releases/allplatforms/studio",
      countryData: "/releases/allcountry/studio",
      monthData: "/releases/allmonth/studio",
      videoData: "/releases/allvideo/studio",
      singleAlbumData: "/releases/albums",
      singleCountryData: "/releases/country",
      singlestoreData: "/releases/platform",
      getMood: 'content_creator/mood/',
      getSwipCategory: 'content_creator/category/user_distinct/',
      officalPlaylist: 'content_creator/playlist/all/?search=official',

      // --------------- song analytics

      songAnalytics: 'content_creator/analytics/song',
      platformAnalytics: 'content_creator/analytics/songPlatform',
      creditLedger: 'content_creator/api/credit-ledger',
      leaderBoard: 'content_creator/api/leader-board',

      // ------------ rating and review --------------

      allsongslist: 'content_creator',
      rating: 'content_creator/rating',
      searchSong: 'content_creator/search_allsongs',
      reviewSongList: 'content_creator/reviews/song',
      // --------------- official playlist --------

      // allsongslist: 'content_creator',
      allPlaylist: 'content_creator/playlist/all/',
      playlistrating: 'content_creator/playlist_rating',
      searchplaylist: 'content_creator/playlist/genre/',
      reviewPlaylistList: 'content_creator/reviews/playlist',
      discoverSongList: 'content_creator/discover-song-list',
      // ----------collab multiple images ----------

      editcollabimage: 'user_auth/edit-profile-picture/',
      getcollabimage: 'user_auth/profile-pictures',
      postcollabimage: 'user_auth/profile-pictures/',
      sequencecollabimage: 'user_auth/profile-pictures-sequence/',
      deletecollabimage: 'user_auth/delete-profile-picture/',
      postCollabArtist: 'user_auth/collaboration-request',

      // ----------- latitude and longitude ---------

      getlatandlongUser: 'user_auth/user',
      getCollabUsers: 'user_auth/users/nearby/',
      platformCreateUpdateDelte: 'content_creator/playlistStreamingPlatforms',
      getSinglePlaylist: 'content_creator/playlists',
      streamingPlatforms: 'content_creator/streamingPlatforms/',
      getrelatedStreamingPlatforms: 'content_creator/getrelatedStreamingPlatforms/song',
      createSongList: 'content_creator/createSongList',

      // ---------------- Artist Campaign ----------------

      songPromotion: 'content_creator/song_promotion',
      songDragdrop: 'content_creator/playlist-song-sequence/',
      reelCampaign: 'content_creator/reelcampaign',
      reel_platforms: 'content_creator/reel_platforms',
      getPackage: 'content_creator/package/',
      songPromotionCampaign: 'content_creator',
      recommendations: 'content_creator/recommendations',
      // --------collaborations ---------
      getCollabRequest: 'user_auth/collaboration',
      getCollabAcceptedRequest: 'user_auth/collaborated-users',
      postCollabRequest: 'user_auth/collaboration-request',

      // -------------- promotion ads ----------------

      adsPromotion: 'content_creator/ads/',

      // -------------dashboard 
      creatorAnalysisData: 'content_creator/user/content-counts/',

      // get song list by user
      userSongList: 'content_creator/getsongList/user/',
      getSongList: 'content_creator/get_visible_songList/user/',
      currency:'content_creator/currencies',

    };
  }

  async get(endpointKey, params = {}, searchParam = null) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (searchParam) {
        endpoint = endpoint + '/' + searchParam;
      }
      params.app = getAppToken();

      const response = await this.api.get(endpoint, {
        params,
        headers: { Authorization: 'Token ' + getSelfToken() },
      });
      return response;
    } catch (error) {
      return error.response;
      // throw new Error('API request failed:', error);
    }
  }

  async post(endpointKey, data = null, searchParam = null) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (searchParam) {
        endpoint = endpoint + '/' + searchParam;
      }
      data.app = getAppToken();
      const response = await this.api.post(endpoint, data, {
        headers: { Authorization: 'token ' + getSelfToken() }
      });
      return response;
    } catch (error) {
      return error.response;

      // throw new Error('API request failed:', { error });
    }
  }
  async delete(endpointKey, params = {}, searchParam = null) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (searchParam) {
        endpoint = endpoint + '/' + searchParam;
      }
      params.app = getAppToken();
      const response = await this.api.delete(endpoint, {
        params,
        headers: { Authorization: 'Token ' + getSelfToken() }
      });
      return response;
    } catch (error) {
      throw new Error('API request failed:', error);
    }
  }

  async put(endpointKey, data = null, searchParam = null, pathParam = null) {
    try {
      let endpoint = this.endpoints[endpointKey];
      if (pathParam) {
        if (endpoint.endsWith('/')) {
          endpoint = `${endpoint}${pathParam}/`;
        } else {
          endpoint = `${endpoint}/${pathParam}/`;
        }
      }
      if (searchParam) {
        const searchParams = new URLSearchParams(searchParam).toString();
        endpoint = `${endpoint}?${searchParams}`;
      }

      data['app'] = getAppToken();
      const response = await this.api.put(endpoint, data, {
        headers: { Authorization: 'token ' + getSelfToken() }
      });

      return response;
    } catch (error) {
      console.log(error.response);
      return error.response;
    }
  }
}



export default new APIService(BASE_URL);
